import React from 'react';
import PropTypes from 'prop-types';
import { alpha, Box, Stack } from '@mui/material';
import { C, DETAIL_CARD_SX } from '../tokens';
import { SectionLabel } from '../atoms';
import TradePlan from '../TradePlan';
import SignalHistoryPanel from '../SignalHistoryPanel';
import DetailScoreSignalCard from './DetailScoreSignalCard';
import DetailKeyReasonsCard from './DetailKeyReasonsCard';
import DetailContextCard from './DetailContextCard';
import DetailComponentsCard from './DetailComponentsCard';

// Vertical stack of detail cards inside the drawer body.
const DetailDrawerBody = ({
  detailDrawer,
  t,
  language,
  locale,
  detailHistory,
  detailHistoryLoading,
  getMetadataLabel,
}) => {
  if (!detailDrawer) return null;
  return (
    <Stack spacing={{ xs: 1.1, sm: 1.5 }}>
      <DetailScoreSignalCard
        detailDrawer={detailDrawer}
        t={t}
        language={language}
        locale={locale}
      />

      <Box sx={DETAIL_CARD_SX}>
        <Box sx={{
          px: 1.4,
          py: 1,
          bgcolor: alpha(C.green, 0.04),
          borderBottom: `1px solid ${alpha(C.green, 0.12)}`,
        }}>
          <SectionLabel>{t('breakoutCandidates.drawer.tradePlan')}</SectionLabel>
        </Box>
        <Box sx={{ px: 1.4, py: 1.1 }}>
          <TradePlan row={detailDrawer} t={t} locale={locale} />
        </Box>
      </Box>

      <DetailKeyReasonsCard
        detailDrawer={detailDrawer}
        t={t}
        language={language}
      />

      <DetailContextCard
        detailDrawer={detailDrawer}
        t={t}
        language={language}
        locale={locale}
      />

      <DetailComponentsCard detailDrawer={detailDrawer} t={t} />

      <Box sx={DETAIL_CARD_SX}>
        <Box sx={{
          px: 1.4,
          py: 1,
          bgcolor: alpha(C.amber, 0.04),
          borderBottom: `1px solid ${alpha(C.amber, 0.12)}`,
        }}>
          <SectionLabel>{t('breakoutCandidates.drawer.signalHistory')}</SectionLabel>
        </Box>
        <Box sx={{ px: 1.4, py: 1.15 }}>
          <SignalHistoryPanel
            detailHistory={detailHistory}
            detailHistoryLoading={detailHistoryLoading}
            t={t}
            getMetadataLabel={getMetadataLabel}
          />
        </Box>
      </Box>
    </Stack>
  );
};

DetailDrawerBody.propTypes = {
  detailDrawer: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  t: PropTypes.func.isRequired,
  language: PropTypes.string,
  locale: PropTypes.string,
  detailHistory: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  detailHistoryLoading: PropTypes.bool,
  getMetadataLabel: PropTypes.func.isRequired,
};

DetailDrawerBody.defaultProps = {
  detailDrawer: null,
  language: 'en',
  locale: 'en-US',
  detailHistory: null,
  detailHistoryLoading: false,
};

export default DetailDrawerBody;
